import { 
  BLANK_NEW_WORKFLOW_DATAS,
  prepareDataToCreateWorkflow,
  prepareDataToUpdateWorkflow,
  modifyReceivedData,
} from "../utils/workflowUtils";
import _ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import {
  getAllWorkflows,
  createNewWorkflow,
  updateWorkflow,
  getWorkflofsByProject
} from "../utils/newDbUtils";
export const workflowModule = {
  state: () => ({
    isUpdated: false,
    newWorkflowsDatas: _.cloneDeep(BLANK_NEW_WORKFLOW_DATAS),
    workflow: {
      name: '',
      project: '',
      geo: '',
      requestType: '',
      mediaType: '',
      genre: '',
      keyword: '',
      slackId: '',
      primary: [],
      secondary: [],
      qc: [],
    },
    workflowData: [],
    workflowClone: {},
    workflowForSpreadsheet: [],
    workflowResponseTotalElements: 0,
    workflowTablePage: 1,
    workflowTableSize: 10,
  }),
  mutations: {
    mSetWorkflowsList(state, payload) {
      state.workflowData = payload;
    },
    mSetWorkflowField(state, payload) {
      state.workflow[payload.field] = payload.value;
      const nameList = [state.workflow.project, state.workflow.geo, state.workflow.requestType, state.workflow.mediaType, state.workflow.genre, state.workflow.keyword]
      const filteredList = nameList.filter(item => item !== undefined && item !== '' && item !== null);
      const name = filteredList.join('_');
      state.workflow.name = name;
    },
    mAddNewWorkflow(state) {
      state.workflowData = [...state.workflowData, ...state.newWorkflowsDatas];
      let newDatas = _.cloneDeep(BLANK_NEW_WORKFLOW_DATAS);
      newDatas[0].id = uuidv4();
      state.newWorkflowsDatas = newDatas;
    },
    mUpdateFormData(state, payload) {
      state.newWorkflowsDatas[0] = payload;
    },
    mClearWorkflow(state) {
      state.workflow = {
        name: '',
        project: '',
        geo: '',
        requestType: '',
        mediaType: '',
        genre: '',
        keyword: '',
        slackId: '',
        primary: [],
        secondary: [],
        qc: [],
      }
    },
    mSaveUpdatedWorkflow(state) {
      const workflowIndex = state.workflowData.findIndex((workflow) => workflow.id === state.newWorkflowsDatas[0].id);
      state.workflowData.splice(workflowIndex, 1, state.newWorkflowsDatas[0]);
    },
    mSetIfUpdated(state, payload) {
      state.isUpdated = payload
    },
    mRemoveWorkflow(state, payload) {
      const workflowIndex = state.workflowData.findIndex((workflow) => workflow.id === payload.id);
      state.workflowData.splice(workflowIndex, 1);
    },
    mSetNewWorkflowDatas(state, payload) {
      state.newWorkflowsDatas = payload
    },
    mAddAnotherWorkflow(state) {
      let newDatas = _.cloneDeep(BLANK_NEW_WORKFLOW_DATAS);
      newDatas[0].id = uuidv4();
      state.newWorkflowsDatas = [...state.newWorkflowsDatas, ...newDatas];
    },
    mAddDuplicateWorkflow(state, payload) {
      state.newWorkflowsDatas.push(payload)
    },
    mUpdateWorkflow(state, payload) {
      const workflowIndex = state.newWorkflowsDatas.findIndex((workflow) => workflow.id === payload.id);
      state.newWorkflowsDatas.splice(workflowIndex, 1, payload);
    },
    mRemoveWorkFlow(state, payload) {
      const workflowIndex = state.newWorkflowsDatas.findIndex((workflow) => workflow.id === payload.id);
      state.newWorkflowsDatas.splice(workflowIndex, 1);
    },
    mClearNewWorkflowDatas(state) {
      let newDatas = _.cloneDeep(BLANK_NEW_WORKFLOW_DATAS);
      newDatas[0].id = uuidv4();
      state.newWorkflowsDatas = newDatas;
    },
    mSaveNewWorkflowClone(state) {
      state.workflowClone = _.cloneDeep(state.newWorkflowsDatas[0]);
    },
    mSetWorkflowForSpreadsheet(state, payload) {
      state.workflowForSpreadsheet = payload
    },
    mAddCopyAsNewWorkflow(state, payload) {
      state.newWorkflowsDatas = [];
      state.isUpdated = false;
      state.newWorkflowsDatas.push(payload);
    },
    mSetWorkflowResponseTotalElements(state, payload) {
      state.workflowResponseTotalElements = payload
    },
    mSetWorkflowTablePage(state, payload) {
      state.workflowTablePage = payload
    },
    mSetWorkflowTableSize(state, payload) {
      state.workflowTableSize = payload
    }
  },
  actions: {
    async aGetWorkflowsList(state, reqData) {
      state.commit('mSetWorkflowsList', []);
      let response = await getAllWorkflows(reqData);
      console.log('response', response, reqData)
      const data = modifyReceivedData(response.data.content);
      state.commit('mSetWorkflowResponseTotalElements', response.data.totalElements);
      state.commit('mSetWorkflowsList', data);
    },
    aSetWorkflowField(state, payload) {
      state.commit('mSetWorkflowField', payload)
    },
    aClearWorkflow(state) {
      state.commit('mClearWorkflow')
    },
    aUpdateFormData(state, payload) {
      state.commit('mUpdateFormData', payload)
    },
    aSetIfUpdated(state, payload) {
      state.commit('mSetIfUpdated', payload)
    },
    aRemoveWorkflow(state, payload) {
      state.commit('mRemoveWorkflow', payload)
    },
    aSetNewWorkflowDatas(state, payload) {
      state.commit('mSetNewWorkflowDatas', payload)
    },
    aAddAnotherWorkflow(state) {
      state.commit('mAddAnotherWorkflow')
    },
    aAddDuplicateWorkflow(state, payload) {
      state.commit('mAddDuplicateWorkflow', payload)
    },
    aUpdateWorkflow(state, payload) {
      state.commit('mUpdateWorkflow', payload)
    },
    aRemoveWorkFlow(state, payload) {
      state.commit('mRemoveWorkflow', payload)
    },
    aClearNewWorkflowDatas(state) {
      state.commit('mClearNewWorkflowDatas')
    },
    aSaveNewWorkflowClone(state) {
      state.commit('mSaveNewWorkflowClone')
    },
    aSetWorkflowForSpreadsheet(state, payload) {
      state.commit('mSetWorkflowForSpreadsheet', payload)
    },
    aAddCopyAsNewWorkflow(state, payload) {
      state.commit('mAddCopyAsNewWorkflow', payload)
    },
    aSetWorkflowResponseTotalElements(state, payload) {
      state.commit('mSetWorkflowResponseTotalElements', payload)
    },
    aSetWorkflowTablePage(state, payload) {
      console.log('payload', payload)
      state.commit('mSetWorkflowTablePage', payload)
    },
    aSetWorkflowTableSize(state, payload) {
      state.commit('mSetWorkflowTableSize', payload)
    }
  },
  getters: {
    gWorkflow: (state) => {
      return state.workflow
    },
    gWorkflowData: (state) => {
      return state.workflowData
    },
    gWorkflowName: (state) => {
      return state.workflow.name
    },
    gIsUpdated: (state) => {
      return state.isUpdated
    },
    gNewWorkflowsDatas: (state) => {
      return state.newWorkflowsDatas
    },
    gWorkflowClone: (state) => {
      return state.workflowClone
    },
    gWorkflowForSpreadsheet: (state) => {
      return state.workflowForSpreadsheet
    },
    gWorkflowResponseTotalElements: (state) => {
      return state.workflowResponseTotalElements
    },
    gWorkflowTablePage: (state) => {
      return state.workflowTablePage
    },
    gWorkflowTableSize: (state) => {
      return state.workflowTableSize
    }
  },
};